import React, { useState } from "react";
import UpgradeCardIcon from "../../assets/UpgradeCardIcon.svg";
import { Button, Image, Text, IconButton } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const UpgradeCard = () => {
  const [show, setShow] = useState(false);
  return (
    <div>
      <Button
        bg="#FCEBA2"
        h={14}
        borderRadius="20px"
        boxShadow="sm"
        _hover={{
          bg: "#FDECC1",
        }}
        className="w-full py-2"
        onClick={() => setShow(!show)}
      >
        <div className="flex justify-between items-center w-full">
          <div className="flex flex-col justify-start text-left">
            <Text
              color="#303030"
              fontFamily="Manrope"
              fontSize="14px"
              fontWeight="700"
              lineHeight="23px"
              marginBottom="4px"
            >
              Upgrade your plan
            </Text>
            <Text
              color="#303030"
              fontFamily="Manrope"
              fontSize="12px"
              fontWeight="500"
            >
              Go Plus!
            </Text>
          </div>
          <Image src={UpgradeCardIcon} w={5} h={5} />
        </div>
      </Button>
      {show && (
        <div>
          <div
            className="z-50 backdrop-blur-xl backdrop-saturate-150 bg-[#1D293933]  bg-overlay/1  0 w-screen h-screen fixed inset-0 sm:p-20"
            aria-hidden="true"
            style={{ opacity: 1 }}
          >
            <div className="w-full z-50 flex flex-col justify-start h-full [--scale-enter:100%] [--scale-exit:100%] [--slide-enter:0px] [--slide-exit:80px] sm:[--scale-enter:100%] sm:[--scale-exit:103%] sm:[--slide-enter:0px] sm:[--slide-exit:0px"  style={{opacity: 1, transform: 'translateY(0px) scale(1) translateZ(0px)'}}>
              <div className="">
                <IconButton
                  size="xl"
                  onClick={() => setShow(!show)}
                  variant="customIconButton"
                  className="text-white text-4xl m-5 z-60 w-auto"
                  colorScheme="gray"
                  icon={<FontAwesomeIcon icon="fa-solid fa-xmark" />}
                />
              </div>
              <div className="w-full h-full z-50 flex flex-col justify-center items-center">
                <div className="text-4xl font-bold text-white my-4">
                  Upgrade your Plan
                </div>
                <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 lg:gap-10 my-4 w-full">
                  <div
                    className="flex flex-col bg-white rounded-xl p-4 md:p-8 w-full sm:w-2/4 lg:w-1/4"
                    style={{
                      boxShadow: "0px 2px 15px 0px #14142B26",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderColor: "#EFF0F6",
                    }}
                  >
                    <div className="text-base  font-semibold text-[#6F6C90]">
                      Lorem ipsum
                    </div>
                    <div className="text-2xl font-black text-[#170F49]">
                      Basic
                    </div>
                    <div className="text-base  font-medium text-[#6F6C90] my-2">
                      Lorem ipsum dolor sit amet doloroli sitiol conse ctetur
                      adipiscing elit.{" "}
                    </div>
                    <div className="text-4xl font-black text-[#170F49] my-3">
                      Free
                    </div>
                    <div className="my-2">
                      <div className="text-base font-bold text-[#170F49] mb-3">
                        What's included?
                      </div>
                      <div className="flex justify-start align-center gap-2 my-2">
                        <div className="bg-[#90BCB5] rounded-full px-[0.4rem]">
                          <FontAwesomeIcon
                            icon="fas fa-check"
                            className="text-white text-sm"
                          ></FontAwesomeIcon>
                        </div>
                        <div className="text-base  font-semibold text-[#170F49]">
                          Lorem ipsum
                        </div>
                      </div>
                      <div className="flex justify-start align-center gap-2 my-2">
                        <div className="bg-[#90BCB5] rounded-full px-[0.4rem]">
                          <FontAwesomeIcon
                            icon="fas fa-check"
                            className="text-white text-sm"
                          ></FontAwesomeIcon>
                        </div>
                        <div className="text-base  font-semibold text-[#170F49]">
                          Lorem ipsum
                        </div>
                      </div>
                      <div className="flex justify-start align-center gap-2 my-2">
                        <div className="bg-[#90BCB5] rounded-full px-[0.4rem]">
                          <FontAwesomeIcon
                            icon="fas fa-check"
                            className="text-white text-sm"
                          ></FontAwesomeIcon>
                        </div>
                        <div className="text-base  font-semibold text-[#170F49]">
                          Lorem ipsum
                        </div>
                      </div>
                      <div className="flex justify-start align-center gap-2 my-2">
                        <div className="bg-[#90BCB5] rounded-full px-[0.4rem]">
                          <FontAwesomeIcon
                            icon="fas fa-check"
                            className="text-white text-sm"
                          ></FontAwesomeIcon>
                        </div>
                        <div className="text-base  font-semibold text-[#170F49]">
                          Lorem ipsum
                        </div>
                      </div>
                    </div>
                    <button className="bg-[#90BCB5] text-white rounded-full p-3 w-full mt-4 font-semibold">
                      Selected
                    </button>
                  </div>
                  <div
                    className="flex flex-col bg-[#BAEAE2] rounded-xl p-4 md:p-8 w-full sm:w-2/4 lg:w-1/4"
                    style={{
                      boxShadow: "0px 2px 15px 0px #14142B26",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderColor: "#BAEAE2",
                    }}
                  >
                    <div className="text-base  font-semibold text-[#6F6C90]">
                      Lorem ipsum
                    </div>
                    <div className="text-2xl font-black text-[#170F49]">
                      Premium
                    </div>
                    <div className="text-base  font-medium text-[#6F6C90] my-2">
                      Lorem ipsum dolor sit amet doloroli sitiol conse ctetur
                      adipiscing elit.{" "}
                    </div>
                    <div className="text-4xl font-black text-[#170F49] my-3">
                      $15
                    </div>
                    <div className="my-2">
                      <div className="text-base font-bold text-[#170F49] mb-3">
                        What's included?
                      </div>
                      <div className="flex justify-start align-center gap-2 my-2">
                        <div className="bg-[#FCEBA2] rounded-full px-[0.4rem]">
                          <FontAwesomeIcon
                            icon="fas fa-check"
                            className="text-[#303030] text-sm"
                          ></FontAwesomeIcon>
                        </div>
                        <div className="text-base  font-semibold text-[#170F49]">
                          Lorem ipsum
                        </div>
                      </div>
                      <div className="flex justify-start align-center gap-2 my-2">
                        <div className="bg-[#FCEBA2] rounded-full px-[0.4rem]">
                          <FontAwesomeIcon
                            icon="fas fa-check"
                            className="text-[#303030] text-sm"
                          ></FontAwesomeIcon>
                        </div>
                        <div className="text-base  font-semibold text-[#170F49]">
                          Lorem ipsum
                        </div>
                      </div>
                      <div className="flex justify-start align-center gap-2 my-2">
                        <div className="bg-[#FCEBA2] rounded-full px-[0.4rem]">
                          <FontAwesomeIcon
                            icon="fas fa-check"
                            className="text-[#303030] text-sm"
                          ></FontAwesomeIcon>
                        </div>
                        <div className="text-base  font-semibold text-[#170F49]">
                          Lorem ipsum
                        </div>
                      </div>
                      <div className="flex justify-start align-center gap-2 my-2">
                        <div className="bg-[#FCEBA2] rounded-full px-[0.4rem]">
                          <FontAwesomeIcon
                            icon="fas fa-check"
                            className="text-[#303030] text-sm"
                          ></FontAwesomeIcon>
                        </div>
                        <div className="text-base  font-semibold text-[#170F49]">
                          Lorem ipsum
                        </div>
                      </div>
                    </div>
                    <button className="bg-white text-[#90BCB5] rounded-full p-3 w-full mt-4 font-semibold">
                      Select
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpgradeCard;
